import useAnalytics from "hooks/useAnalytics";

import { ANALYTICS } from "./constants";

const useStackListAnalytics = () => {
  return useAnalytics({
    page: ANALYTICS.analyticsPage,
  });
};

export default useStackListAnalytics;
